import { modelHandlerIntro } from "./modelHandler/modelHandlerIntro";
import { modelHandlerShowroom } from "./modelHandler/modelHandlerShowroom";

(function () {
  function init() {
    modelHandlerIntro();
    modelHandlerShowroom();
  }

  init();
})();
